import { ofType } from "redux-observable";
import { mapTo, take } from "rxjs/operators";
import { TypeActionTutorial } from "../../../tutorial/actionTutorial";
import { actionGameTrackingUpdateFps } from "../../actionGameTracking";
import { IdGameTrackingFpsEventName } from "../IdGameTrackingFpsEventName";
export var epicGameTrackingFpsMemoryUsageTutorialStarted = function (action$, state$) {
    return action$.pipe(ofType(TypeActionTutorial.Init), take(1), mapTo(actionGameTrackingUpdateFps(IdGameTrackingFpsEventName.TUTORIAL_STARTED)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/fps/epics/epicGameTrackingFpsMemoryUsageTutorialStarted.ts
// module id = 1866
// module chunks = 3